import { Pencil, Plus } from 'lucide-react';

type InlineValueButtonProps = {
  label: string;
  testId: string;
  onClick: () => void;
  disabled?: boolean;
};

export function InlineEditButton({
  label,
  testId,
  onClick,
  disabled = false,
}: Readonly<InlineValueButtonProps>) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={label}
      title={label}
      className="cursor-pointer text-neut-400 hover:text-success-500 shrink-0 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:text-neut-400"
      onClick={onClick}
      disabled={disabled}
    >
      <Pencil size={12} aria-hidden />
    </button>
  );
}

export function MissingValueButton({
  label,
  testId,
  onClick,
  disabled = false,
}: Readonly<InlineValueButtonProps>) {
  return (
    <button
      type="button"
      data-testid={testId}
      className="text-xs text-warning-500 hover:text-warning-600 cursor-pointer flex items-center gap-1 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:text-warning-500"
      onClick={onClick}
      disabled={disabled}
    >
      <Plus size={12} aria-hidden />
      {label}
    </button>
  );
}
